import { CatalogicalSearchBox } from "common/components/CatalogicalSearchBox";
import { SearchBox } from "common/components/SearchBox";
import { SearchExperienceSearchBox } from "common/components/SearchExperienceSearchBox";
import { CATALOG_PROVIDER } from "config";
import React, { FC } from "react";

export interface ISearchBoxProps {
  /**
   * The width of the Search Box
   */
  width?: string;
  /**
   * The query string
   */
  queryText?: string | null;
  /**
   * Whether to toggle the new search experience
   */
  toggleSearchExperience?: boolean;
  /**
   * The touchpoint id for UXM
   */
  touchpointId: string;
}

const SearchBoxFactory: FC<ISearchBoxProps> = (props: ISearchBoxProps) => {
  if (props.toggleSearchExperience) {
    return (
      <SearchExperienceSearchBox queryText={props.queryText} width={props.width} touchpointId={props.touchpointId} />
    );
  } else if (CATALOG_PROVIDER === "catalogical") {
    return <CatalogicalSearchBox queryText={props.queryText} width={props.width} touchpointId={props.touchpointId} />;
  } else {
    return <SearchBox {...props} />;
  }
};

export default SearchBoxFactory;
